<template>
    <div class="form-container">
        <h2>Edit Medical History</h2>
        <hr />

        <form @submit.prevent="submitForm">
            <div class="mb-3">
                <label>Past Illnesses</label>
                <textarea v-model="form.past_illness" class="form-control"></textarea>
                <div v-if="errors.past_illness" class="text-danger small">{{ errors.past_illness[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Surgeries</label>
                <textarea v-model="form.surgeries" class="form-control"></textarea>
                <div v-if="errors.surgeries" class="text-danger small">{{ errors.surgeries[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Family History</label>
                <textarea v-model="form.family_history" class="form-control"></textarea>
                <div v-if="errors.family_history" class="text-danger small">{{ errors.family_history[0] }}</div>
            </div>

            <div class="mb-3 form-check">
                <input type="checkbox" class="form-check-input" v-model="form.alcohol_abuse" id="alcohol_abuse">
                <label class="form-check-label checkbox-label" for="alcohol_abuse">Alcohol Abuse</label>
                <div v-if="errors.alcohol_abuse" class="text-danger small">{{ errors.alcohol_abuse[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Alcohol Comment</label>
                <textarea v-model="form.alcohol_comment" class="form-control"></textarea>
                <div v-if="errors.alcohol_comment" class="text-danger small">{{ errors.alcohol_comment[0] }}</div>
            </div>

            <div class="mb-3 form-check">
                <input type="checkbox" class="form-check-input" v-model="form.tobacco_use" id="tobacco_use">
                <label class="form-check-label checkbox-label" for="tobacco_use">Tobacco Use</label>
                <div v-if="errors.tobacco_use" class="text-danger small">{{ errors.tobacco_use[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Tobacco Comment</label>
                <textarea v-model="form.tobacco_comment" class="form-control"></textarea>
                <div v-if="errors.tobacco_comment" class="text-danger small">{{ errors.tobacco_comment[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Withdrawal Symptoms</label>
                <textarea v-model="form.withdrawal_symptoms" class="form-control"></textarea>
                <div v-if="errors.withdrawal_symptoms" class="text-danger small">{{ errors.withdrawal_symptoms[0] }}
                </div>
            </div>

            <div class="mb-3">
                <label>Allergies</label>
                <textarea v-model="form.allergies" class="form-control"></textarea>
                <div v-if="errors.allergies" class="text-danger small">{{ errors.allergies[0] }}</div>
            </div>

            <div class="mb-3 form-check">
                <input type="checkbox" class="form-check-input" v-model="form.current_treatment" id="current_treatment">
                <label class="form-check-label checkbox-label" for="current_treatment">Current Treatment</label>
                <div v-if="errors.current_treatment" class="text-danger small">{{ errors.current_treatment[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Treatment Details</label>
                <textarea v-model="form.treatment_details" class="form-control"></textarea>
                <div v-if="errors.treatment_details" class="text-danger small">{{ errors.treatment_details[0] }}</div>
            </div>

            <div class="mb-3 form-check">
                <input type="checkbox" class="form-check-input" v-model="form.hospitalization" id="hospitalization">
                <label class="form-check-label checkbox-label" for="hospitalization">Hospitalization</label>
                <div v-if="errors.hospitalization" class="text-danger small">{{ errors.hospitalization[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Hospitalization Details</label>
                <textarea v-model="form.hospitalization_details" class="form-control"></textarea>
                <div v-if="errors.hospitalization_details" class="text-danger small">{{
                    errors.hospitalization_details[0] }}</div>
            </div>

            <div class="mb-3 form-check">
                <input type="checkbox" class="form-check-input" v-model="form.er_visit" id="er_visit">
                <label class="form-check-label checkbox-label" for="er_visit">ER Visit</label>
                <div v-if="errors.er_visit" class="text-danger small">{{ errors.er_visit[0] }}</div>
            </div>

            <div class="mb-3">
                <label>ER Visit Details</label>
                <textarea v-model="form.er_visit_details" class="form-control"></textarea>
                <div v-if="errors.er_visit_details" class="text-danger small">{{ errors.er_visit_details[0] }}</div>
            </div>
            <div v-if="errors.er_visit" class="text-danger small">{{ errors.er_visit[0] }}</div>


            <div class="mb-3">
                <label>Alcohol Comment</label>
                <textarea v-model="form.alcohol_comment" class="form-control"></textarea>
                <div v-if="errors.alcohol_comment" class="text-danger small">{{ errors.alcohol_comment[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Tobacco Comment</label>
                <textarea v-model="form.tobacco_comment" class="form-control"></textarea>
                <div v-if="errors.tobacco_comment" class="text-danger small">{{ errors.tobacco_comment[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Withdrawal Symptoms</label>
                <textarea v-model="form.withdrawal_symptoms" class="form-control"></textarea>
                <div v-if="errors.withdrawal_symptoms" class="text-danger small">{{ errors.withdrawal_symptoms[0] }}
                </div>
            </div>

            <div class="mb-3">
                <label>Allergies</label>
                <textarea v-model="form.allergies" class="form-control"></textarea>
                <div v-if="errors.allergies" class="text-danger small">{{ errors.allergies[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Treatment Details</label>
                <textarea v-model="form.treatment_details" class="form-control"></textarea>
                <div v-if="errors.treatment_details" class="text-danger small">{{ errors.treatment_details[0] }}</div>
            </div>

            <div class="mb-3">
                <label>Hospitalization Details</label>
                <textarea v-model="form.hospitalization_details" class="form-control"></textarea>
                <div v-if="errors.hospitalization_details" class="text-danger small">{{
                    errors.hospitalization_details[0] }}
                </div>
            </div>

            <div class="mb-3">
                <label>ER Visit Details</label>
                <textarea v-model="form.er_visit_details" class="form-control"></textarea>
                <div v-if="errors.er_visit_details" class="text-danger small">{{ errors.er_visit_details[0] }}</div>
            </div>

            <button type="submit" class="btn btn-success mt-2">💾 Save</button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'IopMedicalHistoryForm',
    props: ['iop_medical_print_id'],
    data() {
        return {
            form: {
                iop_medical_print_id: this.iop_medical_print_id,
                past_illness: '',
                surgeries: '',
                family_history: '',
                alcohol_abuse: false,
                tobacco_use: false,
                current_treatment: false,
                hospitalization: false,
                er_visit: false,
                alcohol_comment: '',
                tobacco_comment: '',
                withdrawal_symptoms: '',
                allergies: '',
                treatment_details: '',
                hospitalization_details: '',
                er_visit_details: ''
            },
            errors: {}
        };
    },
    mounted() {
        this.loadForm();
    },
    methods: {
        async loadForm() {
            try {
                const res = await this.$api.get(`/iop-medical-histories/${this.iop_medical_print_id}`);
                if (res.data && Object.keys(res.data).length > 0) {
                    this.form = { ...this.form, ...res.data };
                }
            } catch (err) {
                // Ignore if not exist
            }
        },

        async submitForm() {
            this.errors = {};
            try {
                await this.$api.post(`/iop-medical-histories`, this.form);
                this.$router.back();
            } catch (err) {
                if (err.response?.data?.errors) {
                    this.errors = err.response.data.errors;
                } else {
                    alert('Failed to save Medical History');
                }
            }
        }
    }
}
</script>

<style scoped>
label {
    font-weight: 500;
}

.checkbox-label {
    line-height: 30px;
    margin-left: 10px;

}
</style>